import axios from "axios";

export default {
  namespaced: true,
  state: {
    id: null,
    startAt: '',
    endAt: '',
    title: '',
    showAreas: [],
    message: '',
    filePath: '',
    filename: '',
    attachment: null,
  },

  getters: {
    actionName: state => {
      return state.id ? '編集' : '新規作成'
    },
    url: state => {
      return state.id
        ? `api/v1/admin/notifications/${state.id}`
        : 'api/v1/admin/notifications'
    },
    method: state => {
      return state.id ? 'PUT' : 'POST'
    },
    data: state => {
      let form = new FormData()
      form.append('notification[start_at]', state.startAt)
      form.append('notification[end_at]', state.endAt)
      form.append('notification[title]', state.title)
      form.append('notification[show_areas]]', state.showAreas)
      form.append('notification[message]', state.message)
      if(state.attachment) form.append('notification[attachment]', state.attachment)
      return form
    },
  },

  mutations: {
    setId(state, payload) {
      state.id = payload.id;
    },
    setStartAt(state, payload) {
      state.startAt = payload.startAt;
    },
    setEndAt(state, payload) {
      state.endAt = payload.endAt;
    },
    setTitle(state, payload) {
      state.title = payload.title;
    },
    setShowAreas(state, payload) {
      state.showAreas = payload.showAreas
    },
    setMessage(state, payload) {
      state.message = payload.message;
    },
    setAttachment(state, payload) {
      state.attachment = payload.attachment;
    },
    setNotification(state, payload) {
      Object.assign(state, payload)
    },
    initialize(state) {
      state.id = null
      state.startAt = ''
      state.endAt = ''
      state.title = ''
      state.showAreas = []
      state.message = ''
      state.filePath = ''
      state.filename = ''
      state.attachment = null

    },
  },

  actions: {
    async validate({ state }) {
      // 表示開始日が入力されているか
      if (!state.startAt) return {status: 'error', message: '表示開始日を入力してください'}

      if (state.endAt) {
        // 表示開始日が終了日を超えているか
        if (state.endAt < state.startAt) return {status: 'error', message: '表示開始日が終了日を超えています'}
      }

      // 件名が入力されているか
      if (!state.title) return {status: 'error', message: '件名を入力してください'}

      // 表示箇所が入力されているか
      if (state.showAreas.length === 0) return {status: 'error', message: '表示箇所を選択してください'}

      // 件名が10文字以内か
      if (state.title.length > 30) return {status: 'error', message: '件名は30文字以内で入力してください'}

      // 本文が入力されているか
      if (!state.message) return {status: 'error', message: '本文を入力してください'}
      // 本文の最大文字数チェック(タグは削除してから文字数カウント)
      if (state.message.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'').length > 500) return {status: 'error', message: '本文は500文字以内で入力してください'}

      return {status: 'success', message: ''}
    },
    async submit({ getters }) {
      const notification = getters.data
      const url = getters.url
      const method = getters.method
      const actionName = getters.actionName

      await axios({
        url: url,
        method: method,
        data: notification,
      })
      return {message: `${actionName}が完了しました` }
    },
    async getAttached({ state, commit }, payload) {
      if(!payload.filePath || payload.filePath.length === 0) return
      const res = await axios.get(`/api/v1/admin/notifications/${state.id}/download`, { responseType: 'blob', dataType: 'binary' })
      const blob = new Blob([res.data], { type: res.data.type })
      const file = new File([blob], payload.filename, { type: res.data.type })
      commit('setAttachment', {
        attachment: file,
      })

    },
  },
}
